import { SITE_VARIABLES } from '../../../../../common/styles/variables';
import { flexColumnEndCenter } from '../../../../../common/styles/flex';

interface StylesObject {
  volumeIconStyle: { [key: string]: any };
  volumeIconWrapperStyle: { [key: string]: any };
}

const getVolumeIconStyle = (desktopMode, iconHovered, outsideControlsBar, isRecirculationControls) => {
  let style = {};
  style = { cursor: 'pointer',
    opacity: '0.7',
    color: SITE_VARIABLES.COLORS.WHITE,
    pointerEvents: 'auto',
    marginBottom: '8px' };
  if ((desktopMode && iconHovered)
  || (outsideControlsBar && !desktopMode)
  || isRecirculationControls
  ) {
    style = { ...style, opacity: '1' };
  }
  return style;
};

const volumeIconWrapper = {
  ...flexColumnEndCenter,
  height: '40px',
  width: '40px',
};

export const getVolumeIconStyleObject = (iconHovered: boolean, desktopMode: boolean, isRecirculationControls: boolean, outsideControlsBar?: boolean): StylesObject => ({
  volumeIconStyle: [getVolumeIconStyle(desktopMode, iconHovered, outsideControlsBar, isRecirculationControls)],
  volumeIconWrapperStyle: {
    ...volumeIconWrapper,
  },
});
